import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrChatIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M1 2.7C1 2.3134 1.3134 2 1.7 2H14.7C15.0866 2 15.4 2.3134 15.4 2.7V12.7C15.4 13.0866 15.0866 13.4 14.7 13.4H1.7C1.3134 13.4 1 13.0866 1 12.7V2.7ZM3.61096 3.4L8.2 7.28303L12.789 3.4H3.61096ZM14 4.20927L8.65216 8.73437C8.39117 8.95521 8.00883 8.95521 7.74784 8.73437L2.4 4.20927V12H14V4.20927Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrChatIconComponent;
